import { Record } from "../../../../../../../records/server/crud";

export class MachineConfigurationTypeInfoGamesComponentController {
  static $inject = [];
  constructor() {}

  /*bindings*/
  games!: Record[];
  /*end bindings*/
}
